import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  stock_opnames: [],
};

const getters = {
  allStockOpnames: (state) => state.stock_opnames,
};

const actions = {
  async fetchStockOpnames({ commit }, params = {}) {
    try {
      commit("resetStockOpnames");
      const response = await axios.get("/stock-opname", { params: prm(params) });
      commit("setStockOpnames", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stock_opnames:", error);
    }
  },
  async createStockOpname({ commit }, stock_opname) {
    try {
      const response = await axios.post("/stock-opname", stock_opname);
      commit("addStockOpname", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create stock_opname:", error);
      throw error;
    }
  },
  async fetchStockOpnameById(_, id) {
    try {
      const response = await axios.get(`/stock-opname/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stock_opname:", error);
      throw error;
    }
  },
  async updateStockOpname({ commit }, stock_opname) {
    try {
      const response = await axios.put(`/stock-opname/${stock_opname.id}`, stock_opname);
      commit("updateStockOpname", response.data);
    } catch (error) {
      console.error("Failed to update stock_opname:", error);
      throw error;
    }
  },
  async closeStockOpname({ commit }, stock_opname) {
    try {
      const response = await axios.post(`/stock-opname/close`, stock_opname);
      commit("closeStockOpname", response.data);
    } catch (error) {
      console.error("Failed to close stock_opname:", error);
      throw error;
    }
  },
  async deleteStockOpnameById({ commit }, id) {
    try {
      const response = await axios.delete(`/stock-opname/${id}`);
      commit("removeStockOpname", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete stock_opname:", error);
      throw error;
    }
  },
};

const mutations = {
  setStockOpnames(state, stock_opnames) {
    state.stock_opnames = stock_opnames.data; // Ensure this matches your API's response structure
  },
  addStockOpname(state, stock_opname) {
    state.stock_opnames.push(stock_opname);
  },
  updateStockOpname(state, updatedStockOpname) {
    const index = state.stock_opnames.findIndex(
      (stock_opname) => stock_opname.id === updatedStockOpname.id
    );
    if (index !== -1) {
      state.stock_opnames.splice(index, 1, updatedStockOpname);
    }
  },
  removeStockOpname(state, id) {
    state.stock_opnames = state.stock_opnames.filter(
      (stock_opname) => stock_opname.id !== id
    );
  },
  resetStockOpnames(state) {
    state.stock_opnames = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
